import AscModal from "../AscModal/AscModal";
import AscButton from "../AscButton/AscButton";
import AscHeading from "../AscTypography/AscHeading/AscHeading";
import { CloseIcon } from "../AscIcons";
import classNames from "classnames";
import styles from "./AscModalAddStudent.module.scss";

export interface AscModalAddStudentProps {
  className?: string;
  visible: boolean;
  setVisible: (visible: boolean) => void;
  onClickCSV?: () => void;
  onClickManual?: () => void;
}

export default function AscModalAddStudent({
  className,
  visible,
  setVisible,
  onClickCSV,
  onClickManual,
}: AscModalAddStudentProps) {
  function closeModal() {
    setVisible(false);
  }

  return (
    <AscModal
      visible={visible}
      setVisible={setVisible}
      modalClassName={styles.modalClassName}
      withBackground={false}
    >
      <div className={classNames(styles.element, className)}>
        <CloseIcon
          className={styles.closeIcon}
          onClick={closeModal}
          data-testid={"test-close-icon"}
        />
        <AscHeading className={styles.header}>Add Student</AscHeading>

        <div className={styles.buttonField}>
          <AscButton onClick={onClickCSV} className={styles.button}>
            Upload CSV File
          </AscButton>
          <AscButton onClick={onClickManual} className={styles.button}>
            Manual Upload
          </AscButton>
        </div>
      </div>
    </AscModal>
  );
}
